import request from '@/utils/request'

/**
 * 广告组筛选列表
 * @param {*} params
 * @returns
 */
export const getNewGroup = (params) => {
  return request({
    method: 'GET',
    url: '/sys/v1/newsGroup/page',
    params
  })
}

/**
 * 新增广告组
 * @param {*} data
 * @returns
 */
export const addNewsGroup = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/newsGroup',
    data
  })
}

/**
 * 删除广告组
 * @param {*} id
 * @returns
 */
export const delNewsGroup = (id) => {
  return request({
    method: 'delete',
    url: `/sys/v1/newsGroup/${id}`
  })
}

/**
 * 获取广告组
 * @param {*} id
 * @returns
 */
export const getNewsGroupItem = (id) => {
  return request({
    method: 'GET',
    url: `/sys/v1/newsGroup/${id}`
  })
}

/**
 * 广告位筛选列表
 * @param {*} params
 * @returns
 */
export const getNew = (params) => {
  return request({
    method: 'GET',
    url: '/sys/v1/news/page',
    params
  })
}

/**
 * 新增广告位
 * @param {*} data
 * @returns
 */
export const addNews = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/news',
    data
  })
}

/**
 * 删除广告位
 * @param {*} id
 * @returns
 */
export const delNews = (id) => {
  return request({
    method: 'delete',
    url: `/sys/v1/news/${id}`
  })
}

/**
 * 图片上传
 */
export const uploadImage = (data) => {
  return request({
    method: 'POST',
    url: '/sys/v1/file/uploadImage',
    data
  })
}
